import React from 'react';

export default function NotFound(){
  return (
      <div className="page not-found-page">
        <h1>404 Not Found</h1>
      </div>
  );
}